<script lang="ts" module>
  export type AlertBannerProps = {
    banners: Banner[];
  }
</script>

<script lang="ts">
  import type { Banner } from '../../../types/navData';

  import { css } from '@agapi/ui/panda/css';
  import { icon } from '@agapi/ui/panda/patterns';
  import { alertBannerStyles } from './navbar-alert-banner.styles';
  import { XCircle } from 'phosphor-svelte';
  import { dynamicColorStyles } from '@agapi/ui/panda/utils';
  import { getCookie, setCookie } from '../../../utils';

  const { banners }: AlertBannerProps = $props();
  const currentBanners = $state(banners);

  const classes = alertBannerStyles.raw();
</script>

<ul class={css(classes.root)}>
  {#each currentBanners as banner, index}
  {@const { color, backgroundColor } = dynamicColorStyles(banner.color_variant)}

  <li class={css(classes.item)} style={`color: ${color}; background: ${backgroundColor}`}>
    <span class={css(classes.label)}>{banner.label}</span>
    {#if banner.is_closable}
      <XCircle class={icon({ size: 'sm', cursor: 'pointer' })} onclick={() => {
        const removedBanner = currentBanners.splice(index, 1);
        if (removedBanner.length && removedBanner[0].id) {
          const [{ id }] = removedBanner;
          const removedBanners = getCookie('agapi-navbar-alert-banners');
          setCookie('agapi-navbar-alert-banners', removedBanners ? `${removedBanners},${id}` : `${id}`);
        }
      }} />
    {/if}
  </li>
  {/each}
</ul>
